export default "/images/vendor/flag-icon-css/flags/4x3/ie.svg?5ecf710f14d859cbceb6f20ff89a7c13";